import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import {
  AccountSkeleton,
  AdminDashboardSkeleton,
  CertificatesSkeleton,
  CourseEditorSkeleton,
  DashboardSkeleton,
  GenericPageSkeleton,
  LearnSkeleton,
} from './lms/Skeletons';

interface ProtectedRouteProps {
  children: React.ReactElement;
  requireAdmin?: boolean;
}

const RouteSkeleton: React.FC<{ pathname: string }> = ({ pathname }) => {
  if (pathname === '/dashboard') return <DashboardSkeleton />;
  if (pathname === '/account') return <AccountSkeleton />;
  if (pathname === '/certificates') return <CertificatesSkeleton />;
  if (pathname.startsWith('/learn/')) return <LearnSkeleton />;
  if (pathname.startsWith('/admin/courses/')) return <CourseEditorSkeleton />;
  if (pathname === '/admin') return <AdminDashboardSkeleton />;
  return <GenericPageSkeleton />;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <RouteSkeleton pathname={location.pathname} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
